<template>
  <el-dialog :model-value="visible" @close="close">
    <el-table class="table-td-empty" :header-cell-style="{background:'#D6E9F0', textAlign: 'center'}" border
              :cell-style="{textAlign: 'center'}"
              style="width: 100%"
              :cell-class-name="handleCellClassName" align="center"
              :data="tonnageCode" row-key="id">
      <!--      <el-table-column prop="distanceMax" label="Ballast Distance( Max & Default )" min-width="250" /> -->
      <!--      <el-table-column prop="code" label="Code of Ship Size" min-width="150" /> -->
      <el-table-column prop="shipSizeRange" label="Range of Ship Size( DWT )" min-width="250">
        <template #default="scope">
          [{{ scope.row.sizeMin }} -  {{ scope.row.sizeMax }}] MT
        </template>
      </el-table-column>
      <el-table-column prop="shipType" label="Some Popular Names of Ship Type" min-width="260">
        <template #default="scope">
          <div v-for="title in scope.row.commonTitles" class="cell-div">
            {{ title }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  name: 'TonnageCode',
  props: {
    visible: {
      type: Boolean,
      default: false
    },

    tonnageCode: {
      type: Array,
      default: []
    }
  },

  emits: ['close'],
  setup (props, ctx) {
    const close = () => {
      ctx.emit('close')
    }
    const handleCellClassName = (row, column, rowIndex, columnIndex) => {
      if (row.columnIndex === 1) {
        return 'no-pd'
      }
    }
    return {
      close,
      handleCellClassName
    }
  }
}
</script>

<style lang="less">
.cell-div{
  border-bottom: 1px solid #eaeaea;
  padding: 8px 0;
  &:last-child {
    border-bottom: none;
  }
}
.el-table .el-table__cell.no-pd {
  padding: 0 !important;
.cell {
  padding: 0;
}
}
</style>
